import product_lightbox_gallery from './woocommerce/product-lightbox-gallery';
product_lightbox_gallery()

import product_mobile_gallery from './woocommerce/product-mobile-gallery';
product_mobile_gallery()

import size_chart from './woocommerce/size-chart';
size_chart()

// import archive_product from './shop/archive-product/archive-product';
// archive_product()

import single_product from './woocommerce/single-product';
single_product()

import login_modal from './woocommerce/login-modal';
login_modal()

import checkout from './woocommerce/checkout';
checkout()

// import datalayer from './shop/datalayer/datalayer';
// datalayer()

import my_business_account from './woocommerce/my-business-account';
my_business_account()
export default function(){
	(function($) {

		$('.single-product-summary').on('click',"[data-add-to-cart-quantity-decrease]", () => {
            let $quantity = $('input.qty');
			let value = parseInt($quantity.val())
			if(value > 1){
				$quantity.val(value - 1 )
			}
		}).on('click',"[data-add-to-cart-quantity-increase]", () => {
            let $quantity = $('input.qty');
            let max = $quantity.attr("max") ? parseInt($quantity.attr("max")) : 0,
                    value = parseInt($quantity.val())
            if(!max || value < max){
                $quantity.val(value + 1 )
            }
		})

		// Profession select - if "other" is chosen, show text input field
		$("#bennon__profession-select").on("change", function (){
			if ($(this).val() === "other"){
				$("p.signup__profession_other-wrap").slideDown(200);
			}
			else {
				$("p.signup__profession_other-wrap").slideUp(200);
			}
		})

		// Forms - input labels
		function form_input_label_animation($which){

			$($which + " .form-row").each(function(){
				if( ($(this).find("input").length > 0 && $(this).find("input").val().length > 0) || $(this).find("select").length > 0){
					$(this).closest(".form-row").addClass("active");
				}
			});
			function render_label(){
				let $this = $(this);
				if($this.val().length > 0){
					$this.closest(".form-row").addClass("active");
				}else{
					$this.closest(".form-row").removeClass("active");
				}
			}
			$('body')
				.on('keyup change', ""+$which+" input, "+$which+" textarea", render_label)
				.on('reset', $which, function(){
					let $this = $(this);
					setTimeout(function(){
						$this.find('input, textarea').not('[type="hidden"]').each(render_label);
					}, 0)
				});

		}

		form_input_label_animation(".checkout_form");
		form_input_label_animation(".registration_form");
		form_input_label_animation(".b2b-partner_form");
		form_input_label_animation(".checkout_coupon");
		form_input_label_animation(".bennon_form");
		form_input_label_animation(".lost_reset_password");
		form_input_label_animation(".showroom_search");

	})(jQuery);
}